import React, { useState } from 'react';
import { Toast } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default function Notification({ type, title, message, date, delay }) {
  const [toastState, setToastState] = useState(true);

  const handleClose = () => {
    if (toastState !== false) {
      setToastState(false);
    }
  };

  const defaultBodyClass = 'card-text fw-bolder text-break';

  const bodyTextClass = ['dark', 'danger', 'primary', 'success'].includes(type)
    ? `${defaultBodyClass} text-white`
    : defaultBodyClass;

  return (
    <Toast
      show={toastState}
      onClose={handleClose}
      delay={delay}
      bg={type.toLowerCase()}
      autohide
    >
      <Toast.Header>
        <span className={`dot bg-${type} me-2`} />
        <div className="card-heading text-dark me-auto">{title} </div>
        <small>{date}</small>
      </Toast.Header>

      <Toast.Body className={bodyTextClass}>{message}</Toast.Body>
    </Toast>
  );
}

Notification.defaultProps = {
  type: 'danger',
  title: 'Aviso',
  date: new Date().toLocaleTimeString(),
  delay: 15000,
};

Notification.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  type: PropTypes.string,
  title: PropTypes.string,
  date: PropTypes.string,
  delay: PropTypes.number,
};
